import { render, staticRenderFns } from "./SmoothrPayPayments.vue?vue&type=template&id=db6b9e98"
import script from "./SmoothrPayPayments.vue?vue&type=script&lang=ts"
export * from "./SmoothrPayPayments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports